export default __webpack_public_path__ + "static/media/mavis350.061516b7.webp";